import React from "react";

export function NextJSLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 256"
    >
      <path d="M119.617.069c-.55.05-2.302.225-3.879.35-36.36 3.278-70.419 22.894-91.99 53.044-12.012 16.764-19.694 35.78-22.597 55.922C.125 116.415 0 118.492 0 128.025c0 9.533.125 11.61 1.151 18.64 6.957 48.065 41.165 88.449 87.56 103.411 8.309 2.678 17.067 4.504 27.027 5.605 3.879.425 20.645.425 24.524 0 17.192-1.902 31.756-6.155 46.12-13.486 2.202-1.126 2.628-1.426 2.327-1.677-.2-.15-9.584-12.735-20.845-27.948l-20.47-27.648-25.65-37.956c-14.114-20.868-25.725-37.932-25.825-37.932-.1-.025-.2 16.84-.25 37.431-.076 36.055-.1 37.506-.551 38.357-.65 1.226-1.151 1.727-2.202 2.277-.801.4-1.502.475-5.28.475h-4.33l-1.15-.725a4.679 4.679 0 01-1.677-1.827l-.526-1.126.05-50.166.075-50.192.776-.976c.4-.525 1.251-1.2 1.852-1.526 1.026-.5 1.426-.55 5.755-.55 5.105 0 5.956.2 7.282 1.651.376.4 14.264 21.318 30.88 46.514 16.617 25.195 39.34 59.599 50.5 76.488l20.27 30.7 1.026-.675c9.084-5.905 18.693-14.312 26.3-23.07 16.191-18.59 26.626-41.258 30.13-65.428 1.026-7.031 1.151-9.108 1.151-18.64 0-9.534-.125-11.61-1.151-18.641-6.957-48.065-41.165-88.449-87.56-103.411-8.184-2.652-16.892-4.479-26.652-5.58-2.402-.25-18.943-.525-21.02-.325zm52.401 77.414c1.201.6 2.177 1.752 2.527 2.953.2.65.25 14.562.2 45.913l-.074 44.987-7.933-12.16-7.958-12.16v-32.702c0-21.143.1-33.028.25-33.603.4-1.401 1.277-2.502 2.478-3.153 1.026-.525 1.401-.575 5.33-.575 3.704 0 4.354.05 5.18.5z"></path>
    </svg>
  );
}

export function GitLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      viewBox="0 0 32 32"
    >
      <path
        fill="#f03c2e"
        d="M31.396 14.575L17.425.604a2.06 2.06 0 00-2.914 0l-2.9 2.9 3.68 3.68a2.424 2.424 0 012.518.587 2.45 2.45 0 01.581 2.533l3.547 3.547a2.445 2.445 0 012.533.582 2.45 2.45 0 11-3.469 3.468 2.456 2.456 0 01-.534-2.667l-3.308-3.308v8.705a2.5 2.5 0 01.65.464 2.45 2.45 0 11-3.468 3.468 2.45 2.45 0 010-3.468c.237-.236.5-.415.803-.535v-8.786a2.435 2.435 0 01-.803-.535 2.45 2.45 0 01-.528-2.681l-3.63-3.628-9.58 9.57a2.06 2.06 0 000 2.915l13.972 13.97a2.06 2.06 0 002.914 0L31.396 17.5a2.06 2.06 0 000-2.915"
      ></path>
    </svg>
  );
}

export function NodeJSLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      fill="#8cc84b"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 32 32"
    >
      <path d="M14.656.427c.8-.453 1.82-.455 2.6 0L29.2 7.16c.747.42 1.247 1.253 1.24 2.114v13.5c.005.897-.544 1.748-1.332 2.16l-11.88 6.702a2.6 2.6 0 01-2.639-.073l-3.565-2.06c-.243-.145-.516-.26-.688-.495.152-.204.422-.23.642-.32.496-.158.95-.4 1.406-.656.115-.08.256-.05.366.022l3.04 1.758c.217.125.437-.04.623-.145l11.665-6.583a.386.386 0 00.212-.38V9.334a.417.417 0 00-.25-.417L16.19 2.244a.41.41 0 00-.465-.001L3.892 8.93a.413.413 0 00-.25.415v13.37a.375.375 0 00.215.375l3.162 1.785c.594.32 1.323.5 1.977.265a1.5 1.5 0 00.971-1.409l.003-13.29c-.014-.197.172-.36.363-.34h1.52c.2-.005.357.207.33.405L12.18 23.88c.001 1.188-.487 2.48-1.586 3.063-1.354.7-3.028.553-4.366-.12l-3.4-1.88a2.448 2.448 0 01-1.332-2.16v-13.5a2.46 2.46 0 011.282-2.141L14.656.427zM18.1 9.785c1.727-.1 3.576-.066 5.13.785 1.203.652 1.87 2.02 1.892 3.358-.034.18-.222.28-.394.267-.5-.001-1.002.007-1.504-.003-.213.008-.336-.188-.363-.376-.144-.64-.493-1.273-1.095-1.582-.924-.463-1.996-.44-3.004-.43-.736.04-1.527.103-2.15.535-.48.328-.624 1-.453 1.522.16.383.603.506.964.62 2.082.544 4.287.5 6.33 1.207.845.292 1.672.86 1.962 1.745.378 1.186.213 2.604-.63 3.556-.684.784-1.68 1.2-2.675 1.442-1.323.295-2.695.302-4.038.17-1.263-.144-2.577-.476-3.552-1.336-.834-.724-1.24-1.852-1.2-2.94.01-.184.193-.312.37-.297h1.5c.202-.014.35.16.36.35.093.6.322 1.25.854 1.6 1.026.662 2.313.616 3.487.635.973-.043 2.065-.056 2.86-.7.42-.367.543-.98.43-1.508-.123-.446-.6-.653-1-.8-2.055-.65-4.285-.414-6.32-1.15-.826-.292-1.625-.844-1.942-1.693-.443-1.2-.24-2.687.693-3.607.9-.915 2.22-1.268 3.47-1.394z"></path>
    </svg>
  );
}

export function ExpressJSLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      viewBox="0 0 32 32"
    >
      <path d="M32 24.795c-1.164.296-1.884.013-2.53-.957l-4.594-6.356-.664-.88-5.365 7.257c-.613.873-1.256 1.253-2.4.944l6.87-9.222-6.396-8.33c1.1-.214 1.86-.105 2.535.88l4.765 6.435 4.8-6.4c.615-.873 1.276-1.205 2.38-.883l-2.48 3.288-3.36 4.375c-.4.5-.345.842.023 1.325L32 24.795zM.008 15.427l.562-2.764C2.1 7.193 8.37 4.92 12.694 8.3c2.527 1.988 3.155 4.8 3.03 7.95H1.48c-.214 5.67 3.867 9.092 9.07 7.346 1.825-.613 2.9-2.042 3.438-3.83.273-.896.725-1.036 1.567-.78-.43 2.236-1.4 4.104-3.45 5.273-3.063 1.75-7.435 1.184-9.735-1.248C1 21.6.434 19.812.18 17.9c-.04-.316-.12-.617-.18-.92q.008-.776.008-1.552zm1.498-.38h12.872c-.084-4.1-2.637-7.012-6.126-7.037-3.83-.03-6.58 2.813-6.746 7.037z"></path>
    </svg>
  );
}

export function MongoDBLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      viewBox="0 0 32 32"
    >
      <path
        fill="#599636"
        d="M15.9.087l.854 1.604c.192.296.4.558.645.802a22.406 22.406 0 012.004 2.266c1.447 1.9 2.423 4.01 3.12 6.292.418 1.394.645 2.824.662 4.27.07 4.323-1.412 8.035-4.4 11.12a12.7 12.7 0 01-1.57 1.342c-.296 0-.436-.227-.558-.436a3.589 3.589 0 01-.436-1.255c-.105-.523-.174-1.046-.14-1.586v-.244C16.057 24.21 15.796.21 15.9.087z"
      ></path>
      <path
        fill="#6cac48"
        d="M15.9.034c-.035-.07-.07-.017-.105.017.017.35-.105.662-.296.96-.21.296-.488.523-.767.767-1.55 1.342-2.77 2.963-3.747 4.776-1.3 2.44-1.97 5.055-2.16 7.808-.087.993.314 4.497.627 5.508.854 2.684 2.388 4.933 4.375 6.885.488.47 1.01.906 1.55 1.325.157 0 .174-.14.21-.244a4.78 4.78 0 00.157-.68l.35-2.614L15.9.034z"
      ></path>
      <path
        fill="#c2bfbf"
        d="M16.754 28.845c.035-.4.227-.732.436-1.063-.21-.087-.366-.26-.488-.453a3.235 3.235 0 01-.26-.575c-.244-.732-.296-1.5-.366-2.248v-.453c-.087.07-.105.662-.105.75a17.37 17.37 0 01-.314 2.353c-.052.314-.087.627-.28.906 0 .035 0 .07.017.122.314.924.4 1.865.453 2.824v.35c0 .418-.017.33.33.47.14.052.296.07.436.174.105 0 .122-.087.122-.157l-.052-.575v-1.604c-.017-.28.035-.558.07-.82z"
      ></path>
    </svg>
  );
}

export function SassLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2500"
      height="1875"
      viewBox="0 0 512 384"
      className="Sass"
    >
      <path
        fill="#CF649A"
        d="M440.6 220.6c-17.9.101-33.4 4.4-46.4 10.801-4.8-9.5-9.6-17.801-10.399-24-.9-7.2-2-11.601-.9-20.2C384 178.6 389 166.4 389 165.4c-.101-.9-1.101-5.3-11.4-5.4s-19.2 2-20.2 4.7-3 8.9-4.3 15.3c-1.8 9.4-20.6 42.7-31.3 60.2-3.5-6.8-6.5-12.8-7.101-17.601-.899-7.199-2-11.6-.899-20.199 1.1-8.601 6.1-20.8 6.1-21.8-.1-.9-1.1-5.3-11.399-5.4-10.301-.1-19.2 2-20.2 4.7s-2.1 9.1-4.3 15.3C281.9 201.4 256.9 257 250.4 271.5c-3.3 7.4-6.199 13.3-8.3 17.3-2.1 4-.1.3-.3.7-1.8 3.4-2.8 5.3-2.8 5.3v.101c-1.4 2.5-2.9 4.899-3.601 4.899-.5 0-1.5-6.7.2-15.899 3.7-19.301 12.7-49.4 12.601-50.5 0-.5 1.699-5.801-5.801-8.5-7.3-2.7-9.899 1.8-10.5 1.8-.6 0-1.1 1.6-1.1 1.6s8.1-33.899-15.5-33.899c-14.8 0-35.2 16.1-45.3 30.8-6.4 3.5-20 10.899-34.4 18.8-5.5 3-11.2 6.2-16.6 9.1L117.9 251.9c-28.6-30.5-81.5-52.1-79.3-93.1.8-14.9 6-54.2 101.601-101.8 78.3-39 141-28.3 151.899-4.5 15.5 34-33.5 97.2-114.899 106.3-31 3.5-47.301-8.5-51.4-13-4.3-4.7-4.9-4.9-6.5-4-2.6 1.4-1 5.6 0 8.1 2.4 6.3 12.4 17.5 29.4 23.1 14.899 4.9 51.3 7.6 95.3-9.4 49.3-19.1 87.8-72.1 76.5-116.4-11.5-45.1-86.3-59.9-157-34.8C121.4 27.4 75.8 50.8 43 81.5 4 117.9-2.2 149.7.4 162.9c9.101 47.1 74 77.8 100 100.5-1.3.699-2.5 1.399-3.6 2-13 6.399-62.5 32.3-74.9 59.699-14 31 2.2 53.301 13 56.301 33.4 9.3 67.6-7.4 86.1-34.9 18.399-27.5 16.2-63.2 7.7-79.5l-.301-.6 10.2-6c6.601-3.9 13.101-7.5 18.8-10.601-3.199 8.7-5.5 19-6.699 34-1.4 17.601 5.8 40.4 15.3 49.4 4.2 3.899 9.2 4 12.3 4 11 0 16-9.101 21.5-20 6.8-13.3 12.8-28.7 12.8-28.7s-7.5 41.7 13 41.7c7.5 0 15-9.7 18.4-14.7v.1s.2-.3.6-1a36.13 36.13 0 001.2-1.899v-.2c3-5.2 9.7-17.1 19.7-36.8 12.899-25.4 25.3-57.2 25.3-57.2s1.2 7.8 4.9 20.6c2.199 7.601 6.999 15.9 10.699 24-3 4.2-4.8 6.601-4.8 6.601l.1.1c-2.399 3.2-5.1 6.601-7.899 10-10.2 12.2-22.4 26.101-24 30.101-1.9 4.699-1.5 8.199 2.2 11 2.7 2 7.5 2.399 12.6 2 9.2-.601 15.6-2.9 18.8-4.301 5-1.8 10.7-4.5 16.2-8.5 10-7.399 16.1-17.899 15.5-31.899-.3-7.7-2.8-15.3-5.9-22.5.9-1.3 1.801-2.601 2.7-4 15.8-23.101 28-48.5 28-48.5s1.2 7.8 4.9 20.6c1.899 6.5 5.7 13.601 9.1 20.601-14.8 12.1-24.1 26.1-27.3 35.3-5.9 17-1.3 24.7 7.4 26.5 3.899.8 9.5-1 13.699-2.8 5.2-1.7 11.5-4.601 17.301-8.9 10-7.4 19.6-17.7 19.1-31.6-.3-6.4-2-12.7-4.3-18.7 12.6-5.2 28.899-8.2 49.6-5.7 44.5 5.2 53.3 33 51.601 44.6-1.7 11.601-11 18-14.101 20-3.1 1.9-4.1 2.601-3.8 4 .4 2.101 1.8 2 4.5 1.601 3.7-.601 23.4-9.5 24.2-30.899 1.2-27.504-24.9-57.504-71.2-57.205zM97.4 336.3c-14.7 16.1-35.4 22.2-44.2 17-9.5-5.5-5.801-29.2 12.3-46.3 11-10.4 25.3-20 34.7-25.9 2.1-1.3 5.3-3.199 9.1-5.5.6-.399 1-.6 1-.6.7-.4 1.5-.9 2.3-1.4 6.7 24.4.3 45.8-15.2 62.7zm107.5-73.1c-5.1 12.5-15.9 44.6-22.4 42.8-5.601-1.5-9-25.8-1.101-49.8 4-12.101 12.5-26.5 17.5-32.101 8.101-9 16.9-12 19.101-8.3 2.6 4.801-9.9 39.601-13.1 47.401zm88.7 42.4c-2.2 1.101-4.2 1.9-5.1 1.301-.7-.4.899-1.9.899-1.9s11.1-11.9 15.5-17.4c2.5-3.199 5.5-6.899 8.7-11.1v1.2C313.6 292.1 299.8 301.7 293.6 305.6zm68.399-15.6c-1.6-1.2-1.399-4.9 4-16.5 2.101-4.6 6.9-12.3 15.2-19.6 1 3 1.601 5.899 1.5 8.6-.099 18-12.899 24.7-20.7 27.5z"
      ></path>
    </svg>
  );
}

export function CssLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      version="1.1"
      viewBox="0 0 64 64"
    >
      <g transform="translate(-193.633 -739.48) matrix(.15557 0 0 .15557 185.822 723.826)">
        <path
          fill="#264de4"
          d="M437.367 100.62L404.321 470.819 255.778 512 107.644 470.877 74.633 100.62z"
        ></path>
        <path
          fill="#2965f1"
          d="M256 480.523L376.03 447.246 404.27 130.894 256 130.894z"
        ></path>
        <path
          fill="#ebebeb"
          d="M256 268.217L150.31 268.217 154.38 313.627 256 313.627z"
        ></path>
        <path
          fill="#ebebeb"
          d="M256 176.305L255.843 176.305 142.132 176.305 146.26 221.716 256 221.716z"
        ></path>
        <path
          fill="#ebebeb"
          d="M156.409 336.333L162.771 407.634 255.791 433.457 256 433.399 256 386.153 255.801 386.206 205.227 372.55 201.994 336.333 177.419 336.333z"
        ></path>
        <path
          fill="#fff"
          d="M311.761 313.627L306.49 372.521 255.843 386.191 255.843 433.435 348.937 407.634 349.62 399.962 360.291 280.411 361.399 268.217 369.597 176.305 255.843 176.305 255.843 221.716 319.831 221.716 315.699 268.217 255.843 268.217 255.843 313.627z"
        ></path>
      </g>
    </svg>
  );
}

export function JsLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      fill="none"
      viewBox="0 0 124 141.532"
    >
      <path
        fill="#e9ca32"
        d="M10.383 126.894L0 0l124 .255-10.979 126.639-50.553 14.638z"
      ></path>
      <path
        fill="#ffde25"
        d="M62.468 129.277V12.085l51.064.17-9.106 104.851z"
      ></path>
      <path
        fill="#fff"
        d="M57 26H43.5v78L33 102V91.5l-12.5-2V113l36.5 9.5zm10.127 0H104.5L102 40.95H81.394v24.533H102L99.5 115l-32.373 7.5V107L89 99.5 90.263 79l-23.136 3.35z"
      ></path>
    </svg>
  );
}

export function ReactJSLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      viewBox="0 0 32 32"
    >
      <g
        fill="none"
        fillRule="evenodd"
        transform="translate(.648 2.438) scale(.05696)"
      >
        <circle cx="269.529" cy="237.628" r="50.167" fill="#00d8ff"></circle>
        <g stroke="#00d8ff" strokeWidth="24">
          <path d="M269.53 135.628c67.356 0 129.928 9.665 177.107 25.907 56.844 19.57 91.794 49.233 91.794 76.093 0 27.99-37.04 59.503-98.083 79.728-46.15 15.29-106.88 23.272-170.818 23.272-65.554 0-127.63-7.492-174.3-23.44C36.184 297.006.62 265.085.62 237.628c0-26.642 33.37-56.076 89.415-75.616 47.355-16.51 111.472-26.384 179.486-26.384z"></path>
          <path d="M180.736 186.922c33.65-58.348 73.28-107.724 110.92-140.48C337.006 6.976 380.163-8.48 403.43 4.937c24.248 13.983 33.042 61.814 20.067 124.796-9.8 47.618-33.234 104.212-65.176 159.6-32.75 56.788-70.25 106.82-107.377 139.272-46.98 41.068-92.4 55.93-116.185 42.213-23.08-13.3-31.906-56.92-20.834-115.233 9.355-49.27 32.832-109.745 66.8-168.664z"></path>
          <path d="M180.82 289.482c-33.745-58.282-56.72-117.287-66.31-166.255-11.544-59-3.382-104.11 19.864-117.566 24.224-14.024 70.055 2.244 118.14 44.94 36.356 32.28 73.688 80.837 105.723 136.173 32.844 56.733 57.46 114.21 67.036 162.582 12.117 61.213 2.31 107.984-21.453 121.74-23.057 13.348-65.25-.784-110.24-39.5-38.013-32.71-78.682-83.253-112.76-142.115z"></path>
        </g>
      </g>
    </svg>
  );
}

export function HtmlLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      viewBox="0 0 32 32"
    >
      <path
        fill="#e44d26"
        d="M4.46 28.802L1.892.001h28.216l-2.57 28.797L15.982 32z"
      ></path>
      <path fill="#f16529" d="M25.337 26.964l2.197-24.608H16v27.197z"></path>
      <path
        fill="#ebebeb"
        d="M15.988 5.888H7.142l.953 10.682H16v-3.532h-4.674l-.323-3.617H16V5.888zM16 22.2l-.015.004-3.934-1.062-.25-2.817H8.253l.495 5.546 7.236 2 .016-.005z"
      ></path>
      <path
        fill="#fff"
        d="M15.988 16.57h4.35l-.4 4.58-3.94 1.063v3.675l7.242-2.007.97-10.845H16zm8.764-9.734l.084-.948h-8.85V9.42h8.532l.07-.794z"
      ></path>
    </svg>
  );
}

export function MaleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1"
      viewBox="0 0 980 982"
      className="about-icon"
    >
      <path
        d="M4520 9799c-842-73-1620-343-2318-802-537-355-1042-859-1397-1397-142-216-339-592-458-877C93 6119-37 5297 10 4610c75-1079 449-2017 1134-2845 119-143 360-391 506-519C2394 591 3322 172 4305 46c455-58 966-44 1445 39 503 88 1034 272 1463 506 889 485 1647 1272 2087 2164 539 1096 643 2355 295 3560-87 298-230 633-425 995-327 607-951 1275-1585 1697-640 426-1370 685-2195 779-160 19-714 27-870 13zm860-624c1271-150 2411-853 3104-1912 480-733 728-1604 703-2463-29-972-376-1890-998-2641-25-32-53-67-62-79l-16-23-97 63c-246 159-580 295-1184 480-74 23-255 80-403 126-147 47-272 82-277 79-6-4-10-97-10-238 0-348-22-448-161-737-136-283-280-513-449-723-94-117-313-340-431-440l-56-47h-286l-85 73c-380 322-729 813-927 1303-70 173-77 221-84 529-6 272-7 280-26 279-33-2-1037-321-1225-389-294-107-465-188-636-302-46-31-86-54-88-52-125 148-338 440-451 620-86 136-258 480-322 644-276 707-364 1439-262 2175 95 683 364 1354 770 1922 117 162 225 286 453 514 230 229 370 352 547 476 653 456 1419 730 2189 782 122 8 651-4 770-19z"
        transform="matrix(.1 0 0 -.1 0 982)"
      ></path>
      <path
        d="M4640 8269c-47-5-152-23-235-40-607-122-1072-446-1285-894-135-284-175-548-151-1004 10-212 27-389 46-508 8-46 15-40-71-58-39-9-120-91-151-154-27-53-28-63-28-201 1-126 4-158 28-245 37-134 111-283 192-386 78-99 131-186 249-407 197-373 363-607 578-819 208-207 390-321 637-403 152-50 278-71 442-71 259 0 460 49 689 167 359 186 671 542 976 1116 109 203 183 324 250 408 96 121 162 256 205 425 30 117 33 324 5 395-39 102-122 180-192 180-18 0-36 4-39 10-3 5 4 85 17 177 20 149 22 210 23 543 0 352-2 381-23 476-68 309-184 526-397 740-273 274-662 460-1115 534-146 24-514 35-650 19zm-534-1228c21-15 73-59 114-95 491-439 1082-660 1955-731 105-8 223-18 264-21l74-6-7-88c-9-116-47-362-92-583-19-99-34-181-32-183 3-2 31 47 64 109 69 131 135 207 180 207 43 0 90-34 116-82 17-34 23-64 26-144 7-179-48-335-176-496-85-106-126-177-275-473-192-380-291-533-466-716-291-307-563-412-1021-396-353 12-574 100-806 321-221 209-331 371-544 796-137 274-191 367-261 455-81 101-123 173-154 264-49 150-52 302-7 390 23 44 75 81 114 81 42 0 104-68 172-188 31-56 60-103 64-106 5-3-5 56-20 130-61 292-107 716-95 865 16 187 281 524 500 636 62 31 214 82 248 82 14 1 44-12 65-28zM4574 2702c-177-137-181-159-62-303 22-25 81-81 133-124s95-80 95-82-34-85-76-185c-107-258-231-569-239-599-8-33 51-114 170-232 82-81 265-230 298-243 31-11 349 274 449 404l40 52-23 63c-12 34-85 215-162 402l-139 340 103 100c144 139 209 214 209 239 0 36-35 81-108 140-103 83-106 84-368 92l-229 7-91-71z"
        transform="matrix(.1 0 0 -.1 0 982)"
      ></path>
    </svg>
  );
}

export function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="guide-arrow"
      style={{ width: "5em", height: "5em" }}
      viewBox="0 0 1024 1024"
    >
      <path d="M133.404 349.108l365.132 352.616c1.233 1.138 2.56 2.086 3.983 2.94a18.946 18.946 0 0022.945-2.56l365.132-352.617c7.68-7.395 7.774-19.816 0-27.306-7.396-7.206-19.343-6.827-26.738.379L512.095 662.187H512L160.047 322.18c-7.395-7.206-19.342-7.49-26.737-.38-7.68 7.49-7.586 19.912.094 27.307z"></path>
    </svg>
  );
}

export function LogoName() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="10"
      version="1"
      viewBox="0 0 60 30"
      className="logo-name"
    >
      <path
        fill="#4ca1af"
        fillOpacity="0.302"
        d="M6.645-6.996L1.246-4.941v2.3L6.645-.586V-2.3L2.727-3.797 6.645-5.28zm0 0"
        transform="translate(5.205 20.09)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.302"
        d="M13.258-9.754L12.012-1.82l-1.496-7.934H6.187L4.691-1.82 3.445-9.754H.585L2.114 0h4.969l1.262-7.305L9.62 0h4.984l1.528-9.754zm0 0"
        transform="translate(12.802 20.09)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.302"
        d="M5.777.234c3.684 0 5.016-1.16 5.266-4.324h-3.05C7.89-2.773 7.39-2.156 5.761-2.156c-1.582 0-2.184-.91-2.184-2.7 0-1.832.676-2.742 2.274-2.742 1.582 0 2.023.692 2.113 1.895h3.02c-.208-2.922-1.598-4.285-5.208-4.285-3.886 0-5.265 2.597-5.265 5.133 0 2.597 1.379 5.09 5.265 5.09zm0 0"
        transform="translate(29.227 20.09)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.302"
        d="M.148 0h2.637l3.77-9.754h-2.64zm0 0"
        transform="translate(43.937 20.09)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.302"
        d="M1.246-6.996v1.715l3.918 1.484L1.246-2.3v1.715L6.645-2.64v-2.3zm0 0"
        transform="translate(50.345 20.09)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.502"
        d="M6.645-6.996L1.246-4.941v2.3L6.645-.586V-2.3L2.727-3.797 6.645-5.28zm0 0"
        transform="translate(4.557 19.442)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.502"
        d="M13.258-9.754L12.012-1.82l-1.496-7.934H6.187L4.691-1.82 3.445-9.754H.585L2.114 0h4.969l1.262-7.305L9.62 0h4.984l1.528-9.754zm0 0"
        transform="translate(12.154 19.442)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.502"
        d="M5.777.234c3.684 0 5.016-1.16 5.266-4.324h-3.05C7.89-2.773 7.39-2.156 5.761-2.156c-1.582 0-2.184-.91-2.184-2.7 0-1.832.676-2.742 2.274-2.742 1.582 0 2.023.692 2.113 1.895h3.02c-.208-2.922-1.598-4.285-5.208-4.285-3.886 0-5.265 2.597-5.265 5.133 0 2.597 1.379 5.09 5.265 5.09zm0 0"
        transform="translate(28.579 19.442)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.502"
        d="M.148 0h2.637l3.77-9.754h-2.64zm0 0"
        transform="translate(43.288 19.442)"
      ></path>
      <path
        fill="#4ca1af"
        fillOpacity="0.502"
        d="M1.246-6.996v1.715l3.918 1.484L1.246-2.3v1.715L6.645-2.64v-2.3zm0 0"
        transform="translate(49.697 19.442)"
      ></path>
      <path
        fill="#4ca1af"
        d="M6.645-6.996L1.246-4.941v2.3L6.645-.586V-2.3L2.727-3.797 6.645-5.28zm0 0"
        transform="translate(3.909 18.794)"
      ></path>
      <path
        fill="#4ca1af"
        d="M13.258-9.754L12.012-1.82l-1.496-7.934H6.187L4.691-1.82 3.445-9.754H.585L2.114 0h4.969l1.262-7.305L9.62 0h4.984l1.528-9.754zm0 0"
        transform="translate(11.505 18.794)"
      ></path>
      <path
        fill="#4ca1af"
        d="M5.777.234c3.684 0 5.016-1.16 5.266-4.324h-3.05C7.89-2.773 7.39-2.156 5.761-2.156c-1.582 0-2.184-.91-2.184-2.7 0-1.832.676-2.742 2.274-2.742 1.582 0 2.023.692 2.113 1.895h3.02c-.208-2.922-1.598-4.285-5.208-4.285-3.886 0-5.265 2.597-5.265 5.133 0 2.597 1.379 5.09 5.265 5.09zm0 0"
        transform="translate(27.93 18.794)"
      ></path>
      <path
        fill="#4ca1af"
        d="M.148 0h2.637l3.77-9.754h-2.64zm0 0"
        transform="translate(42.64 18.794)"
      ></path>
      <path
        fill="#4ca1af"
        d="M1.246-6.996v1.715l3.918 1.484L1.246-2.3v1.715L6.645-2.64v-2.3zm0 0"
        transform="translate(49.05 18.794)"
      ></path>
    </svg>
  );
}
